import React from 'react';

import { isEmpty } from 'lodash';

import BobInputField from '../../../../components/BobInputField';
import EquipmentEnergyMonitorPanel from './EquipmentEnergyMonitorPanel';

import * as classes from './EquipmentEnergyPanel.module.css';

const EquipmentEnergyPanel = ({
    availableSensors,
    energyValue,
    equipmentAttributes,
    formik,
    hasValidated,
    sensorAttributes,
    sensors,
    setSensors,
    setEnergyValue,
    setUnit,
    unit,
    ...props
}) => {

    const handleChangeValue = (event, name) => {
        if (name === 'unit') {
            formik.setFieldValue('powerUnit', event.target.value.value);
            formik.setFieldValue(name, event.target.value);
        } else {
            formik.setFieldValue(name, event.target.value);
        }
    };

    const handleBlurValue = (event, name) => {
        formik.setFieldTouched(name, true);
    };

    const handleAddEnergyMonitor = () => {
        let updatedSensors = [...sensors];
        updatedSensors.push({ energyValue: '', powerUnit: '', unit: '', powerValue: '', statusSensor: '', efficiency: '', load: '', volts: '', powerFactor: '', phase: 'singlePhase', energyTargetValue: '' });
        setSensors(updatedSensors);
    };

    return (
        <React.Fragment>
            <style>
                {`.k-floating-label-container.k-empty > .k-label { font-size: 1.2rem; padding-top: 0.2rem }` }
            </style>
            <div className={classes.EnergyForm}>
                <div className={classes.SensorPanel}>
                    {
                        sensors.map((item, index) => {
                            return (
                                <EquipmentEnergyMonitorPanel
                                    activeSensors={sensors}
                                    availableSensors={availableSensors}
                                    energyValue={energyValue}
                                    equipmentAttributes={equipmentAttributes}
                                    formik={formik}
                                    hasValidated={hasValidated}
                                    handleBlurValue={handleBlurValue}
                                    handleChangeValue={handleChangeValue}
                                    setEnergyValue={setEnergyValue}
                                    classes={classes}
                                    sensorIndex={index}
                                    setSensors={setSensors}
                                    sensorAttributes={sensorAttributes}
                                />
                            );
                        })
                    }
                </div>
                <div className={classes.AddEnergyMonitorPanel}>
                    <div className={classes.AddEnergyMonitorButton} role="none" onClick={handleAddEnergyMonitor}>
                        <span className="material-symbols-outlined">add</span> Add Energy Monitor
                    </div>
                </div>
                <div className={classes.LowerPanel}>
                    <div className={classes.Title}>Equipment Energy Target</div>
                    <div>
                        <span className={classes.EnergyUseTarget}>
                            <span className={classes.EnergyUseTitle}>Energy Use Target</span>
                            <span className={classes.InputContainer}>
                                <BobInputField
                                    id={'energyTargetValue'}
                                    name={'energyTargetValue'}
                                    value={formik.values.energyTargetValue}
                                    onChange={handleChangeValue}
                                    onBlur={handleBlurValue}
                                    errors={hasValidated && isEmpty(formik.values.energyTargetValue) && !isEmpty(sensors)}
                                    touched={formik.touched.energyTargetValue}
                                    label={'Value'}
                                    size={'small'}
                                    fillMode={'outline'}
                                    rounded={'medium'}
                                />
                            </span>
                        </span>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default EquipmentEnergyPanel;
